import React from 'react';

const UniversityStudentInfo: React.FC= () => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.4928 16.7314C21.6147 16.6095 22.1511 16.3657 23.3213 16.3657H26.247C27.3441 16.3657 29.6115 17.1703 29.904 20.3885C29.0507 21.2418 26.5395 22.8021 23.3213 22.217C23.687 21.3637 23.8333 19.0719 21.4928 16.7314Z"
      fill="currentColor"
    />
    <path
      d="M16.3745 24.4113C17.4716 24.4113 20.3241 23.8993 22.9572 21.8513C23.0791 20.7542 22.8109 18.2674 20.7629 17.0971C20.3972 16.8533 19.3733 16.3657 18.203 16.3657H13.4488C12.8393 16.4876 11.474 16.9509 10.8889 17.8285C10.1575 18.9257 9.06035 20.3885 9.79176 21.8513C10.5232 22.7046 12.8637 24.4113 16.3745 24.4113Z"
      fill="currentColor"
    />
    <path
      d="M11.2534 16.7314C10.4001 17.219 8.76657 18.9988 9.05914 22.217C7.7181 22.3389 4.59719 22.1439 2.8418 20.3885C2.8418 19.4133 3.28064 17.3166 5.03603 16.7314C5.27984 16.6095 5.98687 16.3657 6.86456 16.3657H9.05914C9.61994 16.3879 10.8439 16.4922 11.2534 16.7314Z"
      fill="currentColor"
    />
    <circle cx="16.3734" cy="11.6116" r="4.02277" fill="currentColor" />
    <circle cx="24.7835" cy="12.3431" r="3.29135" fill="currentColor" />
    <ellipse cx="7.96225" cy="12.3431" rx="3.29135" ry="3.29135" fill="currentColor" />
  </svg>
);

export default UniversityStudentInfo;
